import {cartApi, cartData} from "../cart-api/cart-api"
import {rerenderCartDropdown} from "../cart-dropdown/cart-dropdown--rerender"
import {rerenderProgresses} from "../../components/items/progress-item/progress-item";

export const addToCartInit = () => {
  const products = document.querySelectorAll<HTMLElement>(".i-product-action")

  products.forEach((product) => {
    const addToCartButton = product.querySelector<HTMLElement>(".--js-cart-add");
    const addedToCartMessage = document.querySelector<HTMLElement>(".pd-content__added-to-cart");
    const productId = addToCartButton?.dataset.productId ?? null
    const mass = addToCartButton?.dataset.mass ?? null
    const quantity = parseInt(addToCartButton?.dataset.quantity) ?? 1

    addToCartButton?.addEventListener("click", async (event) => {
      event.preventDefault()

      product.classList.add('--loading');

      if (!productId) {
        console.log("product id is missing")
        return
      }

      const response = await cartApi.add(productId, mass, quantity)

      if (response.ok) {
        const data = (await response.json()) as cartData

        rerenderProgresses(data.progress.remaining, Number(data.progress.percentage))
        rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)
        addedToCartMessage?.classList.add("--open")
        setTimeout(() => {
          addedToCartMessage?.classList.remove("--open")
        }, 1000)
      }

      product.classList.remove('--loading');
    })
  })
}

addToCartInit()
